<section class="container mt-2 border p-3">
    <div class="row">
        <div class="col-12 centrar">
           
            
            <p class="mensaje"><strong>{{mensaje}} <a class="colorMorado" href="https://allproductscol.com/eventos/evento/{{id}}">https://allproductscol.com/eventos/evento/{{id}}</a> </strong></p>
            <button class="botonLogin mt-3 rounded" mat-button mat-dialog-close>Entendido</button>
        </div>
    </div>
</section>